export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const paths = {
  index: "/",
  home: "/home",
  login: "/login",
  signup: "/signup",
  submissionLogin: "/submission-login",
  passwordReset: "/password-reset",
  passwordRecovery: "/password-recovery",
  /** Where every provider sign-in (Google, Microsoft) from this app lands first. */
  welcome: "/welcome",
};

export const MESSAGE_PREFIX = "apps.main.";
